module.exports = __webpack_public_path__ + "img/HZGB01-03-03.65d4c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB01-03-03.png
// module id = M/t9
// module chunks = 0